import TermsSection from "./TermsSection";
import "./style.css";

const EnglishTerms = () => {
  return (
    <div className="container">
      <p className="inter-font text-center">
        Last updated: <span className="fw-light">October 2025</span>
      </p>

      <TermsSection title="1. DEFINITION AND SCOPE">
        <p>
          GARLAS LLC acts as an authorized logistics agent and broker to
          coordinate land and ocean transportation of vehicles, motorcycles,
          boats, and vessels within the United States, to and from Puerto Rico,
          and to Central America (Guatemala, Honduras, and El Salvador). GARLAS
          is not a direct carrier but a licensed logistics intermediary (broker)
          registered with the DOT and FMCSA.
        </p>
      </TermsSection>
      <TermsSection title="2. SERVICES AND LIMITATION OF LIABILITY">
        <p>
          GARLAS coordinates transport through certified land and ocean carriers
          but never takes physical possession of the vehicle. Responsibility for
          loss or delay lies with the carrier or shipping line executing the
          transport. Ocean shipments are also subject to the carrier’s Bill of
          Lading terms. Pickup and delivery dates are estimated and not
          guaranteed.
        </p>
      </TermsSection>
      <TermsSection title="3. CUSTOMER RESPONSIBILITY">
        <p>
          The customer must provide accurate vehicle information, prepare the
          vehicle properly, submit valid documentation, be present or appoint a
          representative at pickup and delivery, inspect and sign the Bill of
          Lading, and report any claims within 48 hours after delivery.
        </p>
      </TermsSection>
      <TermsSection title="4. INOPERABLE AND MODIFIED VEHICLES">
        <p>
          Vehicles that are inoperable or modified must be disclosed at the time
          of booking. Oversized or altered vehicles may incur extra charges or
          be rejected. If a running vehicle becomes inoperable during handling
          or transport, the customer will be responsible for additional winch or
          special handling fees.
        </p>
      </TermsSection>
      <TermsSection title="5. PERSONAL ITEMS AND PROHIBITED ARTICLES">
        <p>
          No personal items are allowed inside the vehicle (only
          factory-installed accessories). Firearms, flammable liquids, drugs,
          money, and documents are prohibited. Any undeclared items travel at
          the customer’s sole risk and may cause the vehicle to be held by port
          or customs authorities.
        </p>
      </TermsSection>
      <TermsSection title="6. CANCELLATIONS AND REFUNDS">
        <p>
          Cancellations before carrier assignment: no fee. After assignment or
          dispatch: $150 USD minimum administrative fee. If the vehicle has been
          loaded or handed to the carrier, additional charges may apply.
          Cancellations must be submitted via email to info@shipshippersusa.com.
          Phone or chat cancellations will not be accepted.
        </p>
      </TermsSection>
      <TermsSection title="7. PAYMENTS AND CHARGES">
        <p>
          All payments must be completed in full prior to shipment or as stated
          on the order confirmation. C.O.D. payments must be made in cash, money
          order, or cashier’s check—personal checks or cards are not accepted.
          Vehicles may be stored at the customer’s expense if delivery is
          refused or payment is incomplete. Late invoices accrue 1.5% monthly
          interest.
        </p>
      </TermsSection>
      <TermsSection title="8. INSURANCE">
        <p>
          Domestic USA: insurance included (FMCSA). | USA«Puerto Rico: optional
          $100 (25k) / $200 (50k) with $1,000 deductible. | USA®Central America:
          not available. GARLAS recommends optional maritime insurance for
          vehicles valued over $15,000 USD.
        </p>
      </TermsSection>
      <TermsSection title="9. CLAIMS FOR LOSS, DAMAGE OR DELAY">
        <p>
          GARLAS is not liable for damage or loss. Claims must be filed directly
          with the carrier or shipping line in accordance with applicable laws
          (Carmack Amendment or Carriage of Goods by Sea Act). GARLAS will
          assist in providing carrier details upon request.
        </p>
      </TermsSection>
      <TermsSection title="10. LIMITATION OF LIABILITY">
        <p>
          The maximum liability of GARLAS for any claim shall not exceed the
          service fees paid for brokerage services. GARLAS does not guarantee
          delivery times, profit, or future market conditions.
        </p>
      </TermsSection>
      <TermsSection title="11. INDEMNIFICATION">
        <p>
          The customer agrees to indemnify and hold GARLAS harmless from any
          claims, fines, or losses arising from false information, legal
          violations, or damages caused by unauthorized or unreported items.
        </p>
      </TermsSection>
      <TermsSection title="12. GOVERNING LAW AND JURISDICTION">
        <p>
          This agreement is governed by the laws of the State of Florida, USA.
          Any disputes shall be resolved in the courts of Miami-Dade County
          unless arbitration is mutually agreed. For Puerto Rico or Central
          America operations, local maritime laws apply.
        </p>
      </TermsSection>
      <TermsSection title="13. CONTRACTUAL RELATIONSHIP">
        <p>
          Nothing in this agreement constitutes partnership, employment, or
          agency. GARLAS and the customer act as independent entities. These
          Terms supersede all prior agreements.
        </p>
      </TermsSection>
      <TermsSection title="14. IMAGE AND PROMOTIONAL RIGHTS">
        <p>
          GARLAS may use the client’s name or logo as a commercial reference
          unless the client opts out by emailing privacy@shipshippersusa.com.
        </p>
      </TermsSection>
      <div className="px-3">
        <div className="mt-5 d-flex">
          <div>
            <h4 className="section-title text-center">LEGAL SUMMARY</h4>
            <div className="lato-font text-center text-start text-black">
              <p style={{ lineHeight: "1.2" }}>
                GARLAS LLC acts as a licensed intermediary, not a carrier.
                Delivery times are estimates, cancellations generate
                administrative fees, maritime insurance is optional, and claims
                must be filed directly with the carrier or shipping line.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnglishTerms;
